module.exports = __webpack_public_path__ + "static/media/instructivoretos.9e6b2666.pdf";